module.exports = __webpack_public_path__ + "static/1_1_defineai_EL-05fdccbdccef1c11c51549d684d6c1a9.svg";